import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectObjectiveOperational } from "../Model/ProposalProjectObjectiveOperational";

export async function createProposalProjectObjectiveOperational(data) {
	let response = await getAPIResponse("/v1/proposal-project-objective-operational", data, "POST");
	if (response === null) {
		return null;
	}
	let proposalProjectObjectiveOperational = ProposalProjectObjectiveOperational.createFromResponseData(response);
	return proposalProjectObjectiveOperational;
}
